// extracted by mini-css-extract-plugin
export default {"informationTooltip":"fGDT65nqLh9RXXLxtv7w","informationTooltipArrow":"LYhBIFqQCLTukUrNrW9f"};